import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

var _this = this;

import React, { useEffect, useRef, useState } from "react";
import { ReactReduxContext, connect } from "react-redux";
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FaChevronLeft } from "react-icons/fa";
import { adaptAccountEvents } from "../../ducks";
import { accountDuck, adaptSCCommerceOrdersAPIToState } from "../../ducks/account";
import * as UTIL from "../../util";
import { apiUtil } from "../../util";
import AccountOrderTabs from "./AccountOrderTabs";
import CurrentOrder from "./CurrentOrder";
import MissingCreditInfo from './MissingCreditInfo';
import DailyLimitReachedModal from './receiptScan/DailyLimitReachedModal';
import MissingCredit from './receiptScan/MissingCredit';
import _500PegsMaxModal from './receiptScan/_500PegsMaxModal';
var url = apiUtil.API.loyalty.getAccountEvents;
var accountOperations = accountDuck.operations;

var AccountOrdersV2 = function AccountOrdersV2(props) {
  var _props$getAccountOrde = props.getAccountOrders,
      getAccountOrders = _props$getAccountOrde === void 0 ? function () {
    return console.log("Get account orders");
  } : _props$getAccountOrde,
      isGuest = props.isGuest,
      _props$toReturn = props.toReturn,
      toReturn = _props$toReturn === void 0 ? function () {
    return "";
  } : _props$toReturn,
      _props$setShowReplace = props.setShowReplacement,
      setShowReplacement = _props$setShowReplace === void 0 ? function () {
    return "";
  } : _props$setShowReplace,
      token = props.token,
      _props$addLineFromOrd = props.addLineFromOrder,
      addLineFromOrder = _props$addLineFromOrd === void 0 ? function () {
    return console.log("Order Again for one line item");
  } : _props$addLineFromOrd,
      useMockOrders = props.useMockOrders,
      isLoadingFromAccountState = props.isLoadingFromAccountState,
      ordersFromRedux = props.ordersFromRedux;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      adaptedSitecoreOrders = _useState2[0],
      setAdaptedSitecoreOrders = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      customerAccountEvents = _useState4[0],
      setCustomerAccountEvents = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      fields = _useState8[0],
      setFields = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      dailyLimitModalFields = _useState10[0],
      setDailyLimitModalFields = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showDailyLimitModal = _useState12[0],
      setShowDailyLimitModal = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      _500PegsMaxModalFields = _useState14[0],
      set500PegsMaxModalFields = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      show500PegsMaxModal = _useState16[0],
      setShow500PegsMaxModal = _useState16[1];

  var _useState17 = useState([{}]),
      _useState18 = _slicedToArray(_useState17, 2),
      combinedOrdersData = _useState18[0],
      setCombinedOrdersData = _useState18[1];

  var flags = useFlags();
  var releaseAddReceiptToAccount = flags['releaseAddReceiptToAccount'] ? flags['releaseAddReceiptToAccount'] : false;
  var releaseReceiptScanTransactionLimitReachedModal = flags['releaseReceiptScanTransactionLimitReachedModal'] ? flags['releaseReceiptScanTransactionLimitReachedModal'] : false;
  var releaseReceiptScanMax500PegModal = flags['releaseReceiptScanMax500PegModal'] ? flags['releaseReceiptScanMax500PegModal'] : false;
  var releaseUseEventsApiForOrderHistoryList = flags['releaseUseEventsApiForOrderHistoryList'] ? flags['releaseUseEventsApiForOrderHistoryList'] : false;
  var releaseCombineSitecoreAndEventsOrdersDstr5547 = flags['releaseCombineSitecoreAndEventsOrdersDstr5547'] ? flags['releaseCombineSitecoreAndEventsOrdersDstr5547'] : false;

  var _useState19 = useState(null),
      _useState20 = _slicedToArray(_useState19, 2),
      currentOrder = _useState20[0],
      setCurrentOrder = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      showOrderDetails = _useState22[0],
      setShowOrderDetails = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      showMissCreditInfo = _useState24[0],
      setShowMissCreditInfo = _useState24[1];

  var topOfAccountOrdersDiv = useRef();
  useEffect(function () {
    var handlePageShow = function handlePageShow(event) {
      // Check if the persisted property of the event is true, indicating that the page is being loaded from the cache
      if (event.persisted) {
        setShowMissCreditInfo(false);
      }
    };

    window.addEventListener('pageshow', handlePageShow);
    return function () {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);
  useEffect(function () {
    if (token === null || token === void 0 ? void 0 : token.jwtIdToken) apiUtil.fetchGet(url, token === null || token === void 0 ? void 0 : token.jwtIdToken).then(function (data) {
      var eventData = adaptAccountEvents(data);
      setCustomerAccountEvents(eventData);
    });
  }, [token === null || token === void 0 ? void 0 : token.jwtIdToken]);

  function combineSitecoreAndEventsOrders(sitecoreOrders, eventsOrders) {
    var combinedOrders = []; // match the mappedOrderNumber from the sitecore orders with the mappedOrderNumber from the events api, 

    var combinedSitecoreOrders = sitecoreOrders.map(function (order) {
      var orderFromEventsApi = eventsOrders.find(function (orderFromEventsApi) {
        return orderFromEventsApi.mappedOrderNumber === order.mappedOrderNumber;
      });
      var now = new Date();
      var orderDate = new Date(order.transactionDate);
      orderDate.setHours(now.getHours());
      orderDate.setMinutes(now.getMinutes());
      orderDate.setSeconds(now.getSeconds());
      order.transactionDate = orderDate.toISOString(); // update the matching order with the handOffType and transactionDate from the events api

      if (orderFromEventsApi) {
        order.handOffType = orderFromEventsApi.handOffType;
        order.transactionDate = orderFromEventsApi.transactionDate;
      }

      return order;
    }); // filter eventsOrders to only include orders that are not already in the combinedSitecoreOrders matching on mappedOrderNumber

    var ordersNotInSitecore = eventsOrders.filter(function (orderFromEventsApi) {
      return !combinedSitecoreOrders.some(function (order) {
        return order.mappedOrderNumber === orderFromEventsApi.mappedOrderNumber;
      });
    });
    combinedOrders = [].concat(_toConsumableArray(combinedSitecoreOrders), _toConsumableArray(ordersNotInSitecore));
    combinedOrders.sort(function (a, b) {
      return new Date(b.transactionDate) - new Date(a.transactionDate);
    });
    return combinedOrders;
  }

  useEffect(function () {
    if (!isGuest && !showOrderDetails && (token === null || token === void 0 ? void 0 : token.jwtIdToken)) {
      getAccountOrders();
    }
  }, [token === null || token === void 0 ? void 0 : token.jwtIdToken, showOrderDetails]);
  useEffect(function () {
    if (useMockOrders && useMockOrders === "true") {
      getAccountOrders().then(function (response) {
        var adaptedSCOrders = adaptSCCommerceOrdersAPIToState(response.data.orders);
        setAdaptedSitecoreOrders(adaptedSCOrders);
        setFields(response.data.fields);
        setIsLoading(false);
      });
    }

    var fields = props.fields;

    if (isLoadingFromAccountState) {
      setIsLoading(isLoadingFromAccountState);
    } else {
      setIsLoading(false);
    }

    if (ordersFromRedux.length >= 0) {
      var adaptedSCOrders = adaptSCCommerceOrdersAPIToState(ordersFromRedux);
      setAdaptedSitecoreOrders(adaptedSCOrders);
    }

    if (fields) {
      setFields(fields);
    }
  }, [ordersFromRedux, isLoadingFromAccountState, useMockOrders]); // conditionally display sitecore orders only, events orders only, or combination of both

  useEffect(function () {
    if (releaseCombineSitecoreAndEventsOrdersDstr5547) {
      var ordersFromEventsApi = customerAccountEvents.filter(function (order) {
        return order.mappedEventType === "orderItem";
      });
      var combinedOrders = combineSitecoreAndEventsOrders(adaptedSitecoreOrders, ordersFromEventsApi);
      setCombinedOrdersData(combinedOrders);
    } else if (releaseUseEventsApiForOrderHistoryList) {
      var _ordersFromEventsApi = customerAccountEvents.filter(function (order) {
        return order.mappedEventType === "orderItem";
      });

      setCombinedOrdersData(_ordersFromEventsApi);
    } else {
      setCombinedOrdersData(adaptedSitecoreOrders);
    }
  }, [adaptedSitecoreOrders, customerAccountEvents, releaseUseEventsApiForOrderHistoryList, releaseCombineSitecoreAndEventsOrdersDstr5547]);

  var handleAreYouMissingPegCreditClick = function handleAreYouMissingPegCreditClick(e) {
    var _props$loyalty, _props$loyalty$accoun, _props$loyalty2, _props$loyalty2$trans;

    e.preventDefault();

    if (((_props$loyalty = props.loyalty) === null || _props$loyalty === void 0 ? void 0 : (_props$loyalty$accoun = _props$loyalty.account) === null || _props$loyalty$accoun === void 0 ? void 0 : _props$loyalty$accoun.Balance) === 500 && releaseReceiptScanMax500PegModal) {
      setShow500PegsMaxModal(true);
    } else if (((_props$loyalty2 = props.loyalty) === null || _props$loyalty2 === void 0 ? void 0 : (_props$loyalty2$trans = _props$loyalty2.transactionLimitInfo) === null || _props$loyalty2$trans === void 0 ? void 0 : _props$loyalty2$trans.transactionLimitReached) && releaseReceiptScanTransactionLimitReachedModal) {
      setShowDailyLimitModal(true);
    } else {
      setShowMissCreditInfo(true);
    }
  };

  var handleHideDailyLimitModal = function handleHideDailyLimitModal() {
    setShowDailyLimitModal(false);
  };

  var handleHide500PegsMaxModal = function handleHide500PegsMaxModal() {
    setShow500PegsMaxModal(false);
  };

  useEffect(function () {
    var _fields$MissingCredit, _fields$MissingCredit2, _fields$MissingCredit3, _fields$MissingCredit4, _fields$MissingCredit5, _fields$MissingCredit6, _fields$MissingCredit12, _fields$MissingCredit13, _fields$MissingCredit14, _fields$MissingCredit15, _fields$MissingCredit16, _fields$MissingCredit17;

    if ((fields === null || fields === void 0 ? void 0 : (_fields$MissingCredit = fields.MissingCredit) === null || _fields$MissingCredit === void 0 ? void 0 : (_fields$MissingCredit2 = _fields$MissingCredit[1]) === null || _fields$MissingCredit2 === void 0 ? void 0 : (_fields$MissingCredit3 = _fields$MissingCredit2.fields) === null || _fields$MissingCredit3 === void 0 ? void 0 : _fields$MissingCredit3.ReceiptScanDailyLimitReachedModal) && (fields === null || fields === void 0 ? void 0 : (_fields$MissingCredit4 = fields.MissingCredit) === null || _fields$MissingCredit4 === void 0 ? void 0 : (_fields$MissingCredit5 = _fields$MissingCredit4[1]) === null || _fields$MissingCredit5 === void 0 ? void 0 : (_fields$MissingCredit6 = _fields$MissingCredit5.fields) === null || _fields$MissingCredit6 === void 0 ? void 0 : _fields$MissingCredit6.ReceiptScanDailyLimitReachedModal.length) >= 1) {
      var _fields$MissingCredit7, _fields$MissingCredit8, _fields$MissingCredit9, _fields$MissingCredit10, _fields$MissingCredit11;

      setDailyLimitModalFields(fields === null || fields === void 0 ? void 0 : (_fields$MissingCredit7 = fields.MissingCredit) === null || _fields$MissingCredit7 === void 0 ? void 0 : (_fields$MissingCredit8 = _fields$MissingCredit7[1]) === null || _fields$MissingCredit8 === void 0 ? void 0 : (_fields$MissingCredit9 = _fields$MissingCredit8.fields) === null || _fields$MissingCredit9 === void 0 ? void 0 : (_fields$MissingCredit10 = _fields$MissingCredit9.ReceiptScanDailyLimitReachedModal) === null || _fields$MissingCredit10 === void 0 ? void 0 : (_fields$MissingCredit11 = _fields$MissingCredit10[0]) === null || _fields$MissingCredit11 === void 0 ? void 0 : _fields$MissingCredit11.fields);
    }

    if ((fields === null || fields === void 0 ? void 0 : (_fields$MissingCredit12 = fields.MissingCredit) === null || _fields$MissingCredit12 === void 0 ? void 0 : (_fields$MissingCredit13 = _fields$MissingCredit12[1]) === null || _fields$MissingCredit13 === void 0 ? void 0 : (_fields$MissingCredit14 = _fields$MissingCredit13.fields) === null || _fields$MissingCredit14 === void 0 ? void 0 : _fields$MissingCredit14.ReceiptScan500PegsMaxModal) && (fields === null || fields === void 0 ? void 0 : (_fields$MissingCredit15 = fields.MissingCredit) === null || _fields$MissingCredit15 === void 0 ? void 0 : (_fields$MissingCredit16 = _fields$MissingCredit15[1]) === null || _fields$MissingCredit16 === void 0 ? void 0 : (_fields$MissingCredit17 = _fields$MissingCredit16.fields) === null || _fields$MissingCredit17 === void 0 ? void 0 : _fields$MissingCredit17.ReceiptScan500PegsMaxModal.length) >= 1) {
      var _fields$MissingCredit18, _fields$MissingCredit19, _fields$MissingCredit20, _fields$MissingCredit21, _fields$MissingCredit22;

      set500PegsMaxModalFields(fields === null || fields === void 0 ? void 0 : (_fields$MissingCredit18 = fields.MissingCredit) === null || _fields$MissingCredit18 === void 0 ? void 0 : (_fields$MissingCredit19 = _fields$MissingCredit18[1]) === null || _fields$MissingCredit19 === void 0 ? void 0 : (_fields$MissingCredit20 = _fields$MissingCredit19.fields) === null || _fields$MissingCredit20 === void 0 ? void 0 : (_fields$MissingCredit21 = _fields$MissingCredit20.ReceiptScan500PegsMaxModal) === null || _fields$MissingCredit21 === void 0 ? void 0 : (_fields$MissingCredit22 = _fields$MissingCredit21[0]) === null || _fields$MissingCredit22 === void 0 ? void 0 : _fields$MissingCredit22.fields);
    }
  }, [fields]);

  if (UTIL.mobileAppUtil.isMobileApp()) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !showOrderDetails || !showMissCreditInfo ? /*#__PURE__*/React.createElement(AccountOrderTabs, {
      orders: combinedOrdersData,
      rewards: customerAccountEvents,
      setShowOrderDetails: setShowOrderDetails,
      setCurrentOrder: setCurrentOrder,
      handleAreYouMissingPegCreditClick: handleAreYouMissingPegCreditClick,
      isLoading: isLoading
    }) : /*#__PURE__*/React.createElement("div", {
      ref: topOfAccountOrdersDiv
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-account-card__nav-container ".concat(showMissCreditInfo ? 'cb-account-card__nav-container--hidden' : '')
    }, !isGuest && !showMissCreditInfo && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "cb-account-card__back",
      onClick: function onClick(e) {
        e.preventDefault();
        setShowOrderDetails(false);
      }
    }, /*#__PURE__*/React.createElement(FaChevronLeft, null)), !showMissCreditInfo && /*#__PURE__*/React.createElement("span", {
      className: "cb-account-card__nav-header"
    }, "Order Details")), !showMissCreditInfo && showOrderDetails ? /*#__PURE__*/React.createElement(CurrentOrder, _extends({
      topOfPageRef: topOfAccountOrdersDiv,
      order: currentOrder,
      isGuest: isGuest,
      returnAction: function returnAction(item) {
        setShowReplacement(true);
        toReturn(item);
      },
      topAction: function topAction(orderId, lineId) {
        addLineFromOrder(orderId, lineId);
      },
      fields: fields
    }, props)) : releaseAddReceiptToAccount ? /*#__PURE__*/React.createElement(MissingCredit, {
      loyalty: props.loyalty,
      setShowMissCreditInfo: setShowMissCreditInfo,
      fields: (fields === null || fields === void 0 ? void 0 : fields.MissingCredit) && (fields === null || fields === void 0 ? void 0 : fields.MissingCredit.length) >= 1 ? fields.MissingCredit[1].fields : {}
    }) : /*#__PURE__*/React.createElement(MissingCreditInfo, {
      setShowMissCreditInfo: setShowMissCreditInfo,
      fields: (fields === null || fields === void 0 ? void 0 : fields.MissingCredit) && (fields === null || fields === void 0 ? void 0 : fields.MissingCredit.length) >= 1 ? fields.MissingCredit[0].fields : {}
    })));
  }

  return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DailyLimitReachedModal, {
      show: showDailyLimitModal,
      hide: handleHideDailyLimitModal,
      model: dailyLimitModalFields
    }), /*#__PURE__*/React.createElement(_500PegsMaxModal, {
      show: show500PegsMaxModal,
      hide: handleHide500PegsMaxModal,
      model: _500PegsMaxModalFields
    }), !showOrderDetails && !showMissCreditInfo ? /*#__PURE__*/React.createElement(AccountOrderTabs, {
      orders: combinedOrdersData,
      rewards: customerAccountEvents,
      setShowOrderDetails: setShowOrderDetails,
      setCurrentOrder: setCurrentOrder,
      handleAreYouMissingPegCreditClick: handleAreYouMissingPegCreditClick,
      isLoading: isLoading
    }) : /*#__PURE__*/React.createElement("div", {
      ref: topOfAccountOrdersDiv
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-account-card__nav-container ".concat(showMissCreditInfo ? 'cb-account-card__nav-container--hidden' : '')
    }, !isGuest && !showMissCreditInfo && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "cb-account-card__back",
      onClick: function onClick(e) {
        e.preventDefault();
        setShowOrderDetails(false);
      }
    }, /*#__PURE__*/React.createElement(FaChevronLeft, null)), !showMissCreditInfo && /*#__PURE__*/React.createElement("span", {
      className: "cb-account-card__nav-header"
    }, "Order Details")), !showMissCreditInfo && showOrderDetails ? /*#__PURE__*/React.createElement(CurrentOrder, {
      topOfPageRef: topOfAccountOrdersDiv,
      order: currentOrder,
      isGuest: isGuest,
      returnAction: function returnAction(item) {
        setShowReplacement(true);
        toReturn(item);
      },
      topAction: function topAction(orderId, lineId) {
        addLineFromOrder(orderId, lineId);
      },
      fields: fields,
      useMockOrders: useMockOrders
    }) : releaseAddReceiptToAccount ? /*#__PURE__*/React.createElement(MissingCredit, {
      loyalty: props.loyalty,
      setShowMissCreditInfo: setShowMissCreditInfo,
      fields: (fields === null || fields === void 0 ? void 0 : fields.MissingCredit) && (fields === null || fields === void 0 ? void 0 : fields.MissingCredit.length) >= 1 ? fields.MissingCredit[1].fields : {}
    }) : /*#__PURE__*/React.createElement(MissingCreditInfo, {
      setShowMissCreditInfo: setShowMissCreditInfo,
      fields: (fields === null || fields === void 0 ? void 0 : fields.MissingCredit) && (fields === null || fields === void 0 ? void 0 : fields.MissingCredit.length) >= 1 ? fields.MissingCredit[0].fields : {}
    })));
  }.bind(_this));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$account, _state$account2, _state$account3, _state$account4, _state$account5;

  return {
    ordersFromRedux: (_state$account = state.account) === null || _state$account === void 0 ? void 0 : _state$account.orders,
    isLoadingFromAccountState: (_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : _state$account2.isLoading,
    showReplacement: (_state$account3 = state.account) === null || _state$account3 === void 0 ? void 0 : _state$account3.showReplacement,
    isError: state.error.isError,
    err: state.error.err,
    token: (_state$account4 = state.account) === null || _state$account4 === void 0 ? void 0 : _state$account4.aadResponse,
    reOrderSuccess: (_state$account5 = state.account) === null || _state$account5 === void 0 ? void 0 : _state$account5.reOrderSuccess,
    loyalty: state.loyalty
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAccountOrders: function getAccountOrders() {
      return dispatch(accountOperations.getAccountOrders());
    },
    toReturn: function toReturn(item) {
      return dispatch(accountOperations.toReturn(item));
    },
    setShowReplacement: function setShowReplacement(el) {
      return dispatch(accountOperations.setShowReplacement(el));
    },
    reOrderItems: function reOrderItems(orderId) {
      return dispatch(accountOperations.reOrderItems(orderId));
    },
    setReOrderSuccess: function setReOrderSuccess(success) {
      return dispatch(accountOperations.responseReOrder(success));
    },
    addLineFromOrder: function addLineFromOrder(orderId, lineId) {
      return dispatch(accountOperations.addLineFromOrder(orderId, lineId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountOrdersV2);